import {
  getUserId,
  getUserSignature,
} from '../../../../services/schibstedAccount';

async function fetchIframeContent(url: string, options?: RequestInit) {
  const userId = await getUserId();
  const userSig = await getUserSignature();

  const response = await fetch(url, {
    headers: {
      'x-spid-sig': String(userSig || ''),
      'x-spid-user': String(userId || ''),
    },
    credentials: 'include',
    ...options,
  });

  if (!response.ok) {
    throw new Error('Failed fetching the paywall content');
  }

  const { html } = await response.json();

  return html;
}

export { fetchIframeContent };
